export const APPLICATION_STEPS = {
  FORM: 0,
  LOGIN: 1,
  SUGGESTIONS: 2,
  CONFIRMATION: 3,
  SUCCESS: 4,
};

export const APPLICATION_STEPS_WITH_LINES_AND_TITLES = [
  APPLICATION_STEPS.FORM,
  APPLICATION_STEPS.LOGIN,
  APPLICATION_STEPS.SUGGESTIONS,
  APPLICATION_STEPS.SUCCESS,
];

export const BREEDER_ONBOARDING_MAX_STEP = 13;
